module.exports = __webpack_public_path__ + "static/team13-adf23a1ffc7194eaeee9dc9e14b259b6.jpg";